<template>
	<div class="navlist">
		<div class="swiper-container">
			<div class="swiper-wrapper" ref='swiper' >
				<div class="swiper-slide" v-for="(item,index) in imgData">
					<img class="img1" :src="item" />
				</div>
			</div>
		</div>
		 <div class="swiper-button-prev swiper-button-white" style="left: 5%;"></div>
		 <div class="swiper-button-next swiper-button-white" style="right: 5%;"></div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	export default {
		name: 'swiper',
		props: ['imgData'],
		mounted() {
			const that = this
			that.mySwiper = new Swiper('.swiper-container', {
				slidesPerView: 6,
				loop: true,
				autoplay: {
					autoplay:true,
				    disableOnInteraction: false,
				  },
				navigation: {
			      nextEl: '.swiper-button-next',
			      prevEl: '.swiper-button-prev',
			    }
			});
		}
	}
</script>

<style lang="less" scoped>
	.navlist {
		width: 1250px;
		margin: 0 auto;
		.swiper-slide {
			width: 189px;
			.img1 {
				width: 189px;
				height: 373px;
			}
		}
		
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Swiper.vue